import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import {BrowserRouter} from "react-router-dom";
import {ShopifyProvider} from "@shopify/hydrogen-react";
import {BasketProvider} from "./context/BasketContext/BasketContext.jsx";
import {NotificationProvider} from "./context/NotificationContext/NotificationContext.jsx";
import * as Sentry from "@sentry/react";
import CookiesProvider from "./context/CookiesContext/CookiesContext.jsx";

Sentry.init({
    dsn: "https://76fd72576581c2eee48be05680e65200@o4509872350232576.ingest.de.sentry.io/4509872354426960",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <ShopifyProvider
            languageIsoCode="PL" // or your store's default language code (e.g., 'PL' for Polish)
            storeDomain={import.meta.env.VITE_SHOPIFY_DOMAIN} // no https://
            storefrontToken="28bd9af9eeb7158f164417836080dbed" // from Shopify admin > apps > custom app
            storefrontApiVersion={import.meta.env.VITE_STOREFRONT_API_VERSION}
            countryIsoCode="PL">
            <NotificationProvider>
                <BasketProvider>
                    <CookiesProvider measurementId={import.meta.env.VITE_GA_MEASUREMENT_ID}>
                        <App/>
                    </CookiesProvider>
                </BasketProvider>
            </NotificationProvider>
        </ShopifyProvider>
    </BrowserRouter>
);
